import React from "react";
import PrintSafesMain from "../../Safes/PrintSafesMain";
import { Dialog } from "@material-ui/core";

export default function ActivityReportPrint(props) {
    const { dataPrint, closePrint, infoPrint } = props;
    return (
        <Dialog
            fullScreen
            open={infoPrint}
            onClose={closePrint}
        >
            <div>
                <PrintSafesMain typePrint={17} docNamePdf={"ActivityReport.pdf"} docName={"ActivityReport"}
                    dataPrint={dataPrint} closePrint={closePrint} />
            </div>
        </Dialog>
    );
}
